import { useState, useEffect, useCallback } from 'react';

// Override de Mercado Pago por evento (caso socio). El backend acota el acceso:
// owner sobre cualquier evento de su org; socio solo sobre el suyo. Si el evento no
// tiene MP propio, cobra con el del boliche.
export default function TabPagos({ event, api }) {
  const [st, setSt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    api.get(`/api/mp/status?event_id=${event.id}`).then(setSt).catch(() => setSt(null)).finally(() => setLoading(false));
  }, [event.id]); // eslint-disable-line
  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    if (p.get('mp') && p.get('ev') === event.id) {
      setMsg({ ok: p.get('mp') === 'connected', text: p.get('mp') === 'connected' ? 'Mercado Pago del evento conectado.' : 'No se pudo conectar. Intentá de nuevo.' });
      p.delete('mp'); p.delete('ev');
      window.history.replaceState({}, '', window.location.pathname + (p.toString() ? '?' + p : ''));
    }
  }, [event.id]);

  async function connect() {
    setBusy(true);
    try {
      const r = await api.get(`/api/mp/connect?event_id=${event.id}&return_url=${encodeURIComponent(window.location.origin)}`);
      if (r.url) window.location.href = r.url; else throw new Error('No se pudo iniciar la conexión');
    } catch (e) { alert(e.message || 'No se pudo iniciar la conexión'); setBusy(false); }
  }
  async function disconnect() {
    if (!window.confirm('¿Desconectar el Mercado Pago de este evento? Va a pasar a cobrar con el Mercado Pago del boliche.')) return;
    setBusy(true);
    try { await api.post(`/api/mp/disconnect?event_id=${event.id}`, {}); setMsg(null); load(); }
    catch (e) { alert(e.message); } finally { setBusy(false); }
  }

  const acc = st?.account;
  const ident = acc?.identification;

  return (
    <div className="lb-fade" style={{ paddingTop: 24, maxWidth: 620 }}>
      <p style={{ color: 'var(--ink-700)', fontSize: 14, marginTop: 0, marginBottom: 18 }}>
        Este evento puede cobrar con una cuenta de Mercado Pago propia (por ejemplo, la de un socio).
        Si no conectás una, cobra con el <b style={{ color: '#fff' }}>Mercado Pago del boliche</b>.
      </p>

      {msg && (
        <div style={{ border: `1px solid ${msg.ok ? 'rgba(46,204,113,0.5)' : 'rgba(200,16,46,0.5)'}`, background: msg.ok ? 'rgba(46,204,113,0.08)' : 'rgba(200,16,46,0.08)', borderRadius: 6, padding: '12px 16px', marginBottom: 16, fontSize: 13, color: msg.ok ? '#2ecc71' : 'var(--red-400)' }}>{msg.text}</div>
      )}

      {loading && <div style={{ color: 'var(--ink-600)', fontSize: 13 }}>Cargando…</div>}

      {!loading && (
        <div className="lb-card" style={{ padding: '22px 24px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            <div style={{ width: 40, height: 40, borderRadius: 8, background: '#009ee3', display: 'grid', placeItems: 'center', color: '#fff', fontWeight: 800, fontSize: 18 }}>MP</div>
            <div>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>Mercado Pago de este evento</div>
              <div style={{ fontSize: 12, color: st?.connected ? '#2ecc71' : (st?.needs_reconnect ? 'var(--red-400)' : 'var(--ink-600)') }}>
                {st?.connected ? 'Cuenta propia conectada' : st?.needs_reconnect ? 'Reconexión requerida' : 'Usa el Mercado Pago del boliche'}
              </div>
            </div>
          </div>

          {st?.needs_reconnect && (
            <div style={{ border: '1px solid rgba(200,16,46,0.5)', background: 'rgba(200,16,46,0.08)', borderRadius: 6, padding: '12px 16px', marginBottom: 16, fontSize: 13, color: 'var(--ink-700)' }}>
              <b style={{ color: 'var(--red-400)' }}>La conexión de este evento expiró.</b> Reconectá para volver a cobrar con esta cuenta.
            </div>
          )}

          {st?.connected && acc && (
            <div style={{ fontSize: 13, color: 'var(--ink-700)', display: 'grid', gap: 6, marginBottom: 18 }}>
              <div><span style={{ color: 'var(--ink-600)' }}>Cuenta: </span><b style={{ color: '#fff' }}>{acc.nickname || acc.email || acc.user_id}</b></div>
              {acc.email && <div><span style={{ color: 'var(--ink-600)' }}>Email: </span>{acc.email}</div>}
              {ident?.number && <div><span style={{ color: 'var(--ink-600)' }}>{ident.type || 'CUIT'}: </span>{ident.number}</div>}
              {st.connected_by?.name && <div><span style={{ color: 'var(--ink-600)' }}>Vinculada por: </span>{st.connected_by.name}</div>}
            </div>
          )}

          {st?.connected
            ? <button className="lb-btn lb-btn--ghost lb-btn--sm" disabled={busy} onClick={disconnect}>Desconectar (usar el del boliche)</button>
            : <button className="lb-btn lb-btn--primary" style={{ background: '#009ee3', borderColor: '#009ee3' }} disabled={busy} onClick={connect}>
                {busy ? 'Redirigiendo…' : (st?.needs_reconnect ? 'Reconectar Mercado Pago' : 'Conectar otro Mercado Pago para este evento')}
              </button>}
        </div>
      )}
    </div>
  );
}
